import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import getWebPSource from '@utils/images/getWebPSource';
import getDoubleDpiSrc from '@utils/images/getDoubleDpiSrc';

function WebPImage({ src }) {
  const srcset = useMemo(() => {
    const webpSrc = getWebPSource(src);
    return src ? getDoubleDpiSrc(webpSrc) : '';
  }, [src]);

  return <source type="image/webp" data-srcset={srcset} />;
}

WebPImage.propTypes = {
  src: PropTypes.string,
};

export default WebPImage;
